<template>
  <v-app>
    <v-app-bar flat>
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <v-app-bar-title>{{ this.title }}</v-app-bar-title>
      <v-spacer></v-spacer>

      <v-switch v-model="darkTheme" @update:model-value="changeTheme"
        :prepend-icon="darkTheme ? mdiWeatherNight : mdiWeatherSunny" hide-details inset class="mr-4" />
      <v-select v-model="selectedLang" :items="selectableLangages" :label="$t('app.language')" hide-details inset
        class="mr-4 language-selector" style="max-width: 200px;" variant="underlined"></v-select>
    </v-app-bar>
    <v-main>
      <router-view :lang="selectedLang" />
    </v-main>
    <v-footer>
      <v-col class="text-center mt-4" cols="12">
        Copyright &copy; {{ new Date().getFullYear() }} <strong>Pocketpair, Inc.</strong>
      </v-col>
    </v-footer>
    <v-dialog v-model="isShowSelectLangDialog" max-width="400" persistent>
      <v-card :prepend-icon="mdiTranslate" :title="$t('app.language')" :text="$t('app.selectLanguage')">
        <v-select v-model="selectedLang" :items="selectableLangages" :label="$t('app.language')"
          class="mr-4 ml-4 language-selector" variant="underlined" @vue:mounted="dialogMounted"></v-select>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn @click="isShowSelectLangDialog = false">
            OK
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { ref } from 'vue'
import { useTheme } from 'vuetify'
import { mdiWeatherNight, mdiWeatherSunny, mdiTranslate } from '@mdi/js'

export default {
  name: 'App',
  setup() {
    const theme = useTheme()
    const darkTheme = ref(window.matchMedia('(prefers-color-scheme: dark)').matches)

    const changeTheme = () => {
      theme.global.name.value = darkTheme.value ? 'dark' : 'light'
    }

    changeTheme()

    return {
      darkTheme,
      changeTheme,
      mdiWeatherNight,
      mdiWeatherSunny,
      mdiTranslate
    }
  },
  data() {
    return {
      title: "Home",
      isShowSelectLangDialog: false,
      selectedLang: "en",
      selectableLangages: [],
      // 言語コードと表示名、ファイル名のマッピング
      languageMap: {
        ja: "日本語",
        en: "English",
        zh_Hant: "中文（繁體）",
        zh_Hans: "中文（简体）",
        fr: "Français (France)",
        it: "italiano",
        de: "Deutsch",
        es: "español",
        ko: "한국어",
        pt_Br: "Português (Brasil)",
        ru: "Русский",
        id: "Bahasa Indonesia",
        th: "แบบไทย",
        es_Mx: "Español - América Latina",
        tr: "Türkçe",
        vi: "Tiếng Việt",
        pl: "Polski",
      }
    }
  },
  provide() {
    return {
      setTitle: this.setTitle
    }
  },
  mounted() {
    Object.keys(this.languageMap).forEach((key) => {
      const value = this.languageMap[key]
      this.selectableLangages.push({ title: value, value: key })
      if (this.$i18n.locale.includes(key)) {
        this.selectedLang = key
      }
    })
    //
    this.isShowSelectLangDialog = true
    this.disableInputs()
  },
  watch: {
    selectedLang() {
      this.$i18n.locale = this.selectedLang
      document.querySelector('html').setAttribute('lang', this.selectedLang)
    },
  },
  methods: {
    setTitle(text) {
      document.title = text + " | Pocketpair, Inc."
      this.title = text
    },
    dialogMounted() {
      this.disableInputs()
    },
    disableInputs() {
      var inputs = document.querySelectorAll(".language-selector input")
      inputs.forEach((input) => {
        input.setAttribute("readonly", "readonly")
        input.setAttribute("disabled", "")
      })
    },
  }
}
</script>

<style>
/* .language-selector input{
  position: absolute;
  left: 25vw;
} */
</style>
